import React, { useEffect, useState, useContext } from 'react';
import Loading from '../Loading';
import { useForm } from 'react-hook-form';
import { Container, Row, Col } from 'react-bootstrap';
import TabBar from '../TabBar';
import EditProfileTabOptions from './EditProfileTabOptions';
import { useHistory } from 'react-router-dom';
import { 
  EDIT_USER_INFO_LIST, 
  EDIT_BUSINESS_INFO_LIST, 
  EDIT_BUSINESS_ADDITIONAL_LIST,
  NAICS_LIST, 
  OPP_CLASS_LIST, 
  SETASIDE_LIST,
  PAYMENT_TYPES,
  BUSINESS_TYPE_LIST,
  SHIPPING_TERMS_LIST,
  STATE_LIST,
  PSC_LIST
} from '../../constans';
import { TabContext } from '../../context/TabContext';
import ActionContainer from './ActionContainer';
import AlertMessage from '../AlertMessage';
import Modal from '../UI/Modal';
import ModalContent from './ModalContent';
import { profileGet, userPost, businessPut, matchSettingsGet, matchSettingsPut } from '../../api';
import { UserContext } from '../../context/User';
import { editedNotice, somethingWentWrongNotice } from '../UI/Notifications';

const BUSINESS_EDIT_PROFILE_TAB_BAR_ITEMS = [
  {
    label: "User Info",
    value: "user_info"
  },
  {
    label: "Business Info",
    value: "business_info"
  },
  {
    label: "Match Info",
    value: "match_info"
  }
];

const EDIT_MATCHES_ALERT = `
  <div>
    <p class="mb-0">
      The MatchForce system will run it's matching algorithm every 2 hours. If you make changes to your profile<br />
      information and are expecting new matches to appear, please be sure to wait the 2 hours before looking again
    </p>
  </div>
`;

const DEFAULT_INPUT_VALUES = {
  user: {
    username: "",
    email: "",
    password: "",
    user_message: false,
    user_contact: false
  },
  business: {
    name: "",
    url: "",
    contact: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    county: "",
    zip: "",
    phone: "",
    fax: "",
    type: "",
    description: "",
    keywords: "",
    contract_number: "",
    duns_number: "",
    cage: "",
    tax: "",
    naics: "",
    payment_method: "",
    shipping_terms: "",
    email: "",
    set_aside: "",
    psc_code: ""
  },
  settings: {
    custom_states: [],
    match_keywords: false,
    match_naicses: false,
    option: "enabled"
  }
}

const REQUEST_TYPE = {
  'user_info': userPost,
  'business_info': businessPut,
  'match_info': businessPut
}

const BusinessEditProfile = () => {
  const [active, setActive] = useState('user_info');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit } = useForm();
  const { register: register2, handleSubmit: handleSubmit2 } = useForm();
  const [inputValue, setInputValue] = useState(DEFAULT_INPUT_VALUES)
  const [selectValue, setSelectValue] = useState([]);
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [advancedMatchSettings, setAdvancedMatchSettings] = useState(false);
  const { user, setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [currentInfoTrigger, setCurrentInfoTrigger] = useState(false);
  const [settingId, setSettingId] = useState(null);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  const getInputCurrentUserData = (response) => {
    setInputValue({
      ...inputValue,
      user: {
        ...inputValue.user,
        username: response.username,
        user_contact: response.user_contact,
        email: response.email,
        user_message: response.user_message
      },
      business: {
        ...inputValue.business,
        ...response.business
      }
    })
  }

  const getLabel = (value, options) => {
    for (let index in options) {
      if (options[index].value === value) {
        return options[index].label
      }
    }
  }

  const getSelectCurrentData = (response) => {
    let select = [];

    for (let key in response) {
      if (Array.isArray(response[key])) {
        switch (key) {
          case 'naics':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, NAICS_LIST), value: item, type: "naics"}
            })]
            break;
          case 'psc_code':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, PSC_LIST), value: item, type: "psc_code"}
            })]
            break;
          case 'type':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, BUSINESS_TYPE_LIST), value: item, type: "type"}
            })]
            break;
          case 'set_aside':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, SETASIDE_LIST), value: item, type: "set_aside"}
            })]
            break;
          case 'payment_method':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, PAYMENT_TYPES), value: item, type: "payment_method"}
            })]
            break;
          case 'shipping_terms':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, SHIPPING_TERMS_LIST), value: item, type: "shipping_terms"}
            })]
            break;
          case 'custom_states':
            select = [...select, ...response[key].map(item => {
              return {label: getLabel(item, STATE_LIST), value: item, type: "state"}
            })]
            break;
          default:
        }
      }
    }

    setSelectValue([
      ...selectValue,
      ...select
    ])
  }

  const currentInfoRequest = request => {
    setLoading(true)
    const user_id = user.id;

    request({user_id})
      .then(response => {
        getInputCurrentUserData(response.data);
        getSelectCurrentData(response.data.business);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  const getMatchSettings = () => {
    matchSettingsGet()
      .then(response => {
        getSelectCurrentData(response.data.settings);
        setInputValue({
          ...inputValue,
          settings: {
            ...response.data.settings
          }
        })
        setSettingId(response.data.id);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  useEffect(() => {
    currentInfoRequest(profileGet)
  }, [currentInfoTrigger]);

  const handleMultiDelete = (name, valuesFunc, valuesValue) => {
    switch (name.action) {
      case 'remove-value':
        valuesFunc([...valuesValue.filter(el => el.value !== name.removedValue.value)]);
        break;
      case 'clear':
        valuesFunc([...valuesValue.filter(el => el.type !== name.name)]);
        break;
      default:
    }
  }

  // const handleClose = action => {
  //   if (action === "cancel") {
  //     setSelectValue(selectValue.filter(item => item.type !== "state"))
  //   }

  //   setShow(false);
  // }
  // const handleShow = () => setShow(true);

  const handleMultiAdd = (item, valuesFunc, valuesValue) => {
    switch (item.type) {
      case 'payment_method':
      case 'naics':
      case 'type':
      case 'shipping_terms':
      case 'set_aside':
      case 'state':
      case 'psc_code':
        valuesFunc([...valuesValue, item]);
        break;
      default:
        valuesFunc([...valuesValue.filter(i => i.type !== item.type), item]);
    }
  }

  const setLimitSelectValues = (data, value, blackList = null) => {
    let i = 0;

    if (blackList === null) blackList = [];

    const newList = data.filter(item => {
      if (item.label.toLowerCase().includes(value.toLowerCase()) && i < 10) {
        if (!blackList.includes(item.value)) i++;
        return item
      }
    })

    setList(newList);
  }

  const onChangeHandler = (value, name, action) => {
    switch (name) {
      case 'opp_type':
        setList(OPP_CLASS_LIST);
        break;
      case 'type':
        setList(BUSINESS_TYPE_LIST);
        break;
      case 'set_aside':
        setList(SETASIDE_LIST);
        break;
      case 'naics':
        setLimitSelectValues(NAICS_LIST, value);
        break;
      case 'psc_code':
        setLimitSelectValues(PSC_LIST, value);
        break;
      case 'payment_method':
        setList(PAYMENT_TYPES);
        break;
      case 'shipping_terms':
        setList(SHIPPING_TERMS_LIST);
        break;
    }

    if (action && action.action === "input-change") {
      setInputValue({ ...inputValue, [name]: value });
    }

    if (!value) setList([]);
  }

  const str2bool = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  }

  const onChangeSingleValue = (event, name, infoType) => {
    setInputValue({
      ...inputValue,
      [infoType]: {
        ...inputValue[infoType],
        [name]: str2bool(event.target.value)
      }
    })
  }

  const handleMultiChange = (event, name) => {
    const item = Array.isArray(event) ? event[event.length - 1] : "";

    if (name.removedValue || name.removedValues) {
      handleMultiDelete(name, setSelectValue, selectValue);
    } else if (item) {
      handleMultiAdd(item, setSelectValue, selectValue);
    } else if (event && event.type) {
      setSelectValue([...selectValue, event]);
    }
  }

  const dataTransformation = params => {
    for (let prop in params) {
      if (
        params[prop] === null || 
        params[prop] === undefined ||
        prop === "password" && !params[prop]
      ) {
        delete params[prop];
      }

      if (params[prop] === 'false') {
        params[prop] = false
      } else if (params[prop] === 'true') {
        params[prop] = true
      }

      if (prop === "keywords") {
        params[prop] = params[prop].split(',').map(item => item.trim()).filter(item => item);
      }
    }

    return params;
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);
    
    let obj = {
      naics: [],
      type: [],
      payment_method: [],
      shipping_terms: [],
      set_aside: [],
      psc_code: []
    };
    
    selectValue.forEach((item) => {
      obj[item.type].push(item.value);
    })

    if (active === 'user_info') {
      obj = {};
    }

    const params = {
      ...data,
      ...obj
    }

    const transformedParams = dataTransformation(params);
    request(active, transformedParams)
  };
  
  const request = (active, transformedParams) => {
    REQUEST_TYPE[active](transformedParams)
      .then(response => {
        editedNotice();
        if (active === "user_info") setUser(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setCurrentInfoTrigger(true);
        setLoading(false);
      })
  }

  // const onSubmitAdvanced = (data, e) => {
  //   setLoading(true);
  //   setAdvancedMatchSettings(true);
  //   setShow(false);

  //   const params = {
  //     ...data
  //   }
    
  //   const transformedParams = dataTransformation(params);

  //   transformedParams.custom_states = [];

  //   selectValue.forEach((item) => {
  //     if (item.type === "state") transformedParams["custom_states"].push(item.value);
  //   })
    
  //   matchSettingsPut(transformedParams, { settings_id: settingId })
  //     .then(response => {
  //       editedNotice();
  //       setLoading(false);
  //     })
  //     .catch(error => {
  //       handleDefaultStatusCodes(error.response.status);
  //       setLoading(false);
  //     })
  // }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              Edit Profile
            </h3>
          </Col>
        </Row>
        {active === 'match_info' && (
          <Row>
            <Col>
              <AlertMessage 
                alertMessage={EDIT_MATCHES_ALERT}
                spaces="mt-0 mb-5"
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <TabBar
              active={active}
              setActive={setActive}
              tabItems={BUSINESS_EDIT_PROFILE_TAB_BAR_ITEMS}
            />
          </Col>
        </Row>
        <TabContext.Provider value={{
          register,
          register2,
          handleMultiChange, 
          onChangeHandler, 
          list, 
          inputValue, 
          selectValue, 
          setInputValue, 
          setSelectValue,
          onChangeSingleValue,
          getMatchSettings,
          setLoading
        }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {active === 'user_info' && <EditProfileTabOptions inputList={EDIT_USER_INFO_LIST} />}
                {active === 'business_info' && <EditProfileTabOptions inputList={EDIT_BUSINESS_INFO_LIST} />}
                {active === 'match_info' && <EditProfileTabOptions inputList={EDIT_BUSINESS_ADDITIONAL_LIST} />}
              </Col>
            </Row>
            <Row>
              <Col>
                <ActionContainer 
                  active={active}
                />
              </Col>
            </Row>
          </form>
          {/* <Modal 
            handleClose={handleClose} 
            show={active === "match_info" && show}
            handleSubmit={handleSubmit2}
            onSubmitAdvanced={onSubmitAdvanced}
          >
            <ModalContent />
          </Modal> */}
        </TabContext.Provider>
      </Container>
      {loading && <Loading />}
    </section>
  )
}

export default BusinessEditProfile;